module.exports = __webpack_public_path__ + "img/vertical_3_5_6005.8631abd0.png";